<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-title class="greyk lighten-4k">
          <h3>Dashboard</h3>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm4>
              <v-card>
                <v-card-title primary-title style="background:darkblue;color: white;">
                  <div>
                    <h4 class="headline mb-0">Students</h4>
                  </div>
                </v-card-title>
                <!--<v-divider></v-divider>-->
                <v-card-text style="background:darkblue;color: white;">
                  <v-layout row wrap class="stat-data">
                    <v-flex xs4>
                      <v-icon style="color: white">people_outline</v-icon>
                    </v-flex>

                    <v-flex xs8>
                      <h2>{{ students ? students.length : 0 }}</h2>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions style="background: #fafafa;color:#333">
                  <p>Students Count</p>
                </v-card-actions>
              </v-card>
            </v-flex>

            <v-flex xs12 sm4>
              <v-card>
                <v-card-title primary-title style="background:darkgreen;color: white;">
                  <div>
                    <h4 class="headline mb-0">Employees</h4>
                  </div>
                </v-card-title>
                <!--<v-divider></v-divider>-->
                <v-card-text style="background:darkgreen;color: white;">
                  <v-layout row wrap class="stat-data">
                    <v-flex xs4>
                      <v-icon style="color: white">people</v-icon>
                    </v-flex>

                    <v-flex xs8>
                      <h2>{{ teachers.length + oemployees.length }}</h2>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions style="background: #fafafa;color:#333">
                  <p>Emplyees Count</p>
                </v-card-actions>
              </v-card>
            </v-flex>

            <v-flex xs12 sm4>
              <v-card>
                <v-card-title primary-title style="background:darkslategray;color: white;">
                  <div>
                    <h4 class="headline mb-0">Classes</h4>
                  </div>
                </v-card-title>
                <!--<v-divider></v-divider>-->
                <v-card-text style="background:darkslategray;color: white;">
                  <v-layout row wrap class="stat-data">
                    <v-flex xs4>
                      <v-icon style="color: white">border_all</v-icon>
                    </v-flex>

                    <v-flex xs8>
                      <h2>{{ classes.length }}</h2>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-actions style="background: #fafafa;color:#333">
                  <p>Classes Count</p>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>

          <!-- <v-layout row wrap>
                  <v-flex xs12 sm4>
                    <v-card class="elevation-6">
                      <v-card-title>
                        New Students
                        </v-card-title>
                        <v-divider/>
                        <v-card-text>

                        </v-card-text>
                        <v-card-actions>

                        </v-card-actions>
                    </v-card>
                  </v-flex>
                   <v-flex xs12 sm4>
                    <v-card class="elevation-6">
                      <v-card-title>
                        Recent Subjects
                        </v-card-title>
                        <v-divider/>
                        <v-card-text>

                        </v-card-text>
                        <v-card-actions>

                        </v-card-actions>
                    </v-card>
                  </v-flex>
                   <v-flex xs12 sm4>
                    <v-card class="elevation-6">
                      <v-card-title>
                        Other
                        </v-card-title>
                        <v-divider/>
                        <v-card-text>

                        </v-card-text>
                        <v-card-actions>

                        </v-card-actions>
                    </v-card>
                  </v-flex>

          </v-layout>-->
          <v-expansion-panel>
            <v-expansion-panel-content>
              <template v-slot:header>
                <div>Financial Overview</div>
              </template>
              <v-layout row wrap>

                <v-flex xs12 sm4>
                  <v-card>
                    <v-card-title primary-title style="background:darkgreen;color: white;">
                      <div>
                        <h4 class="headline mb-0">Income</h4>
                      </div>
                    </v-card-title>
                    <!--<v-divider></v-divider>-->
                    <v-card-text style="background:darkgreen;color: white;">
                      <v-layout row wrap class="stat-data">
                        <v-flex xs4>
                          <v-icon style="color: white">money</v-icon>
                        </v-flex>

                        <v-flex xs8>
                          <h2>{{ total_income | toCurrency }}</h2>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-card-actions style="background: #fafafa;color:#333">
                      <p>Total Income</p>
                    </v-card-actions>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm4>
                  <v-card>
                    <v-card-title primary-title style="background:darkred;color: white;">
                      <div>
                        <h4 class="headline mb-0">Expenses</h4>
                      </div>
                    </v-card-title>
                    <!--<v-divider></v-divider>-->
                    <v-card-text style="background:darkred;color: white;">
                      <v-layout row wrap class="stat-data">
                        <v-flex xs4>
                          <v-icon style="color: white">money</v-icon>
                        </v-flex>

                        <v-flex xs8>
                          <h2>{{ total_expense | toCurrency }}</h2>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-card-actions style="background: #fafafa;color:#333">
                      <p>Total Expense</p>
                    </v-card-actions>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm4>
                  <v-card>
                    <v-card-title primary-title style="background:darkslategray;color: white;">
                      <div>
                        <h4 class="headline mb-0">Est. Profits</h4>
                      </div>
                    </v-card-title>
                    <!--<v-divider></v-divider>-->
                    <v-card-text style="background:darkslategray;color: white;">
                      <v-layout row wrap class="stat-data">
                        <v-flex xs4>
                          <v-icon style="color: white">money</v-icon>
                        </v-flex>

                        <v-flex xs8>
                          <h2>{{ (total_income - total_expense) | toCurrency }}</h2>
                        </v-flex>
                      </v-layout>
                    </v-card-text>

                    <v-card-actions style="background: #fafafa;color:#333">
                      <p>Estimated Profits</p>
                    </v-card-actions>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>



        </v-card-text>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "admin-dash",
  layout: "admin",
  metaInfo() {
    return { title: this.$t("home") };
  },
  created() {
    if (this.$route.params && this.$route.params.frmAcct == true) {
      localStorage.setItem("frmAdmin", false)
    }

    this.$store.dispatch("students/getAll");

    this.$store.dispatch("oemployees/getAll");

    this.$store.dispatch("teachers/getAll");

    this.$store.dispatch("classes/getAll");

    this.$store.dispatch("incomes/getAll", { type: 1 });

    this.$store.dispatch("expenses/getAll", { type: 0 });

    this.$store.dispatch("feepayments/getAll");

    //console.log("oemployeeooooo",oemployee)
  },
  computed: {
    ...mapGetters({

      students: "students/STUDENTS",
      sloading: "students/STUDENT_LOADING",

      oemployees: "oemployees/OEMPLOYEES",
      errors: "oemployees/OEMPLOYEE_ERROR",
      loading: "oemployees/OEMPLOYEE_LOADING",

      teachers: "teachers/TEACHERS",
      terrors: "teachers/TEACHER_ERROR",
      tloading: "teachers/TEACHER_LOADING",

      classes: "classes/CLASSES",
      cerrors: "classes/CLASS_ERROR",
      cloading: "classes/CLASS_LOADING",

      incomes: "incomes/INCOMES",
      expenses: "expenses/EXPENSES",

      feepayments: "feepayments/FEEPAYMENTS",
      ferrors: "feepayments/FEEPAYMENT_ERROR"
    }),

    total_income() {
      var fromJournal = this.incomes.reduce((a, b) => {
        return a + parseFloat(b["amount"]);
      }, 0);

      var fromFeesPayments = this.feepayments ? this.feepayments.reduce((a, b) => {
        return a + parseFloat(b.tot_paid);
      }, 0) : 0

      return (
        parseFloat(fromJournal ? fromJournal : 0) +
        (fromFeesPayments ? fromFeesPayments : 0)
      );
    },
    total_expense() {
      return this.expenses.reduce((a, b) => {
        return a + parseFloat(b["amount"]);
      }, 0);
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/dashboard.vue